class MakerStarter {
  constructor() {
    this.init();
  }

  init() {
    console.log("MakerStarter Theme Script initialized");
  }
}

export default MakerStarter;
